import React, { useEffect, useRef } from 'react';
import { ThemeMode } from '../../types/models';
import AppSubnav from './AppSubnav';

interface AppLayoutProps {
  uiTheme: ThemeMode;
  isRefreshing: boolean;
  onRefresh: () => void;
  onThemeToggle: () => void;
  children: React.ReactNode;
}

const AppLayout: React.FC<AppLayoutProps> = ({
  uiTheme,
  isRefreshing,
  onRefresh,
  onThemeToggle,
  children,
}) => {
  const topbarRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    const topbar = topbarRef.current;
    if (!topbar) return undefined;

    const handleThemeRequest = () => onThemeToggle();
    topbar.addEventListener('portal-theme-toggle', handleThemeRequest);

    return () => {
      topbar.removeEventListener('portal-theme-toggle', handleThemeRequest);
    };
  }, [onThemeToggle]);

  return (
    <div className="u2-shell u2-shellWithSidebar">
      <portal-sidebar current-slug="resale-sms" data-theme={uiTheme} />

      <div className="u2-body">
        <portal-topbar
          ref={topbarRef}
          service-name="SMS"
          current-slug="resale-sms"
          theme-enabled="true"
          data-theme={uiTheme}
        />

        <AppSubnav isRefreshing={isRefreshing} onRefresh={onRefresh} />

        <main className="u2-main">
          <div className="u2-container">{children}</div>
        </main>
      </div>
    </div>
  );
};

export default AppLayout;
